import React, { Fragment } from 'react';
import { styled } from 'linaria/react';

import Accordion from '@jetshop/ui/Accordion/Accordion';

import {
  ProductSection as UIProductSection,
  SectionHeading
} from '../ProductPage/ProductInfo';

export const CenterBlock = styled('div')``;

const ProductSection = styled(UIProductSection)`
  border-bottom: 1px solid #545454;
  padding: 0.5rem 0;
  margin: 1rem 0;
  font-size: 0.875rem;
  ${SectionHeading} {
    display: flex;
    justify-items: space-between;
    align-items: center;
    margin-bottom: 0;
    + * > :first-child {
      margin-top: 1rem;
    }
    span {
      font-size: 0.85rem;
      &:last-child {
        font-size: 1.2rem;
      }
    }
  }

  div {
    text-align: left;
    padding: 0 10px;
  }
`;

const IndicatorIcon = styled('span')`
  margin-left: auto;
  font-size: 1.25rem;
`;

const AccordionIndicator = ({ isOpen }) => (
  <IndicatorIcon>{isOpen ? '-' : '+'}</IndicatorIcon>
);

export const AccordionItem = ({
  children,
  title,
  index,
  openIndexes,
  handleClick,
  AccordionContent
}) => (
  <ProductSection key={index}>
    <SectionHeading onClick={() => handleClick(index)}>
      <span>{title}</span>
      <AccordionIndicator isOpen={openIndexes.includes(index)} />
    </SectionHeading>

    <AccordionContent isOpen={openIndexes.includes(index)}>
      {children}
    </AccordionContent>
  </ProductSection>
);

const AccordionBlock = ({ children }) => (
  <Accordion single>
    {({ openIndexes, handleClick, AccordionContent }) => (
      <Fragment>
        {children.map((child, index) => (
          <AccordionItem
            key={index}
            openIndexes={openIndexes}
            handleClick={handleClick}
            AccordionContent={AccordionContent}
            children={child.props.children}
            title={child.props.title}
            index={index}
          />
        ))}
      </Fragment>
    )}
  </Accordion>
);

export default AccordionBlock;
